import { Button, Modal, Table } from "antd";
import React, { useEffect, useState } from "react";
import { SuccessToast } from "../../../../widgets/AppToast";
import AppInput from "../../../../components/AppInput";
import SelectInput from "../../../../components/SelectInput";
import { EditOutlined } from "@ant-design/icons";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { fuelTypeOptions, lubOilTypeOptions } from "../../../../Data/data";
import OrbConfiguration from "./OrbConfiguration";

const categoryData = [
  {
    label: "IOPP 3.1",
    value: "IOPP 3.1",
  },
  {
    label: "IOPP 3.3",
    value: "IOPP 3.3",
  },
  {
    label: "FO",
    value: "FO",
  },
  {
    label: "LO",
    value: "LO",
  },
  {
    label: "FW tank",
    value: "FW tank",
  },
];

function AddTanks({ id, onSuccess }) {
  const [activeSubTab, setActiveSubTab] = useState("tankRegistry");
  const [FilteredData, setFilteredData] = useState([]);
  const [errors, set_errors] = useState({});
  const [tank_list, set_tank_list] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tank_type, set_tank_type] = useState(1);
  const [tank_name, set_tank_name] = useState("");
  const [capacity, set_capacity] = useState("");
  const [category, setCategory] = useState("IOPP 3.1");
  const [tank_id, set_tank_id] = useState("");
  const [update_status, set_update_status] = useState(false);
  const [oil_type, set_Oil_Type] = useState("");
  const [orbConfigurationRefresh, setOrbConfigurationRefresh] = useState(0);

  const GET_TANKS_LIST_APIS = async () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      post(ApiURL.list_tanks_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.tanks);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    }
  };

  const ADD_TANK_API = async () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("category_of_tank", tank_type);
      FORM_DATA.append("sub_tank_name", tank_name);
      FORM_DATA.append("capacity", capacity);
      FORM_DATA.append("tank_type", category);
      FORM_DATA.append("fuel_type", oil_type);
      post(ApiURL.create_tank_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast(
            "Add Tanks Details Saved!",
            "Tank Details Successfully Added!!"
          );
          GET_TANKS_LIST_APIS();
          setOrbConfigurationRefresh((value) => value + 1);
          set_tank_type("");
          set_tank_name("");
          set_capacity("");
          setCategory("");
          setIsModalOpen(false);
          if (onSuccess) onSuccess();
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } finally {
    }
  };

  const UPDATE_TANK_API = async () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("category_of_tank", tank_type);
      FORM_DATA.append("sub_tank_name", tank_name);
      FORM_DATA.append("capacity", capacity);
      FORM_DATA.append("tank_type", category);
      FORM_DATA.append("tank_id", tank_id);
      FORM_DATA.append("fuel_type", oil_type);
      post(ApiURL.update_tank_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast(
            "Update Tanks Details Saved!",
            "Update Tank Details Successfully!!"
          );
          set_tank_type("");
          set_tank_name("");
          set_capacity("");
          setCategory("");
          setIsModalOpen(false);
          GET_TANKS_LIST_APIS();
          setOrbConfigurationRefresh((value) => value + 1);
          if (onSuccess) onSuccess();
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } finally {
    }
  };

  const VIEW_TANK_API = async (tank_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("tank_id", tank_id);
      post(ApiURL.update_tank_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const tanks_data = res?.tank_data;
          set_tank_type(tanks_data?.category_id);
          set_Oil_Type(tanks_data?.fuel_type);
          set_tank_name(tanks_data?.sub_tank_name);
          set_capacity(tanks_data?.capacity);
          setCategory(tanks_data?.tank_type);
          set_update_status(tanks_data?.update_status);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } finally {
    }
  };

  const GET_TANKS_LIST = async () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_tank_categories_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const tanks_Data = res?.tank_categories;
          const tempdata = tanks_Data?.map((item) => ({
            value: item?.id,
            label: item?.tank_name,
          }));
          set_tank_list(tempdata);
        }
      });
    } catch (error) {
      console.error("Error get tanks list:", error);
    }
  };

  useEffect(() => {
    GET_TANKS_LIST();
    GET_TANKS_LIST_APIS();
  }, []);

  // const showHideModal = (_items) => {
  //   setIsModalOpen(!isModalOpen);
  //   if (isModalOpen === false) {
  //     set_tank_name("");
  //     set_capacity("");
  //     setCategory("");
  //   }
  //   if (_items?.id) {
  //     VIEW_TANK_API(_items?.id);
  //     set_tank_id(_items?.id);
  //   }
  // };

  const showHideModal = (_items) => {
    setIsModalOpen(!isModalOpen);

    if (!isModalOpen) {
      set_tank_name("");
      set_capacity("");
      setCategory("");
      set_tank_type(1);
      set_Oil_Type("");
      set_tank_id("");
      set_update_status(false);
    }

    if (_items?.id) {
      VIEW_TANK_API(_items?.id);
      set_tank_id(_items?.id);
      set_update_status(true);
    }
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      align: "center",
    },
    {
      title: "Category Name ",
      dataIndex: "category_name",
      key: "category_name",
      align: "center",
    },
    {
      title: "Tank Name ",
      dataIndex: "sub_tank_name",
      key: "sub_tank_name",
      align: "center",
    },

    {
      title: "Capacity",
      dataIndex: "capacity",
      key: "capacity",
      align: "center",
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (text, record) => {
        if (!record?.created_at) return "N/A";
        const date = new Date(record.created_at);
        return date.toISOString().slice(0, 19).replace("T", " ");
      },
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      key: "updated_at",
      align: "center",
      render: (text, record) => {
        if (!record?.updated_at) return "N/A";
        const date = new Date(record.updated_at);
        return date.toISOString().slice(0, 19).replace("T", " ");
      },
    },
    {
      title: "Action",
      key: "Action",
      align: "center",
      render: (text, record) => {
        return (
          <>
            <Button
              type="primary"
              size="small"
              onClick={() => {
                showHideModal(record);
              }}
              style={{ marginRight: "5px" }}
            >
              <div className="tooltip">
                <EditOutlined />
                <span className="tooltiptext">Edit</span>
              </div>
            </Button>
          </>
        );
      },
    },
  ];

  return (
    <div className="white-container" style={{ position: "relative" }}>
      <div className="white-containers">
        <ul className="sub-marine-tabs">
          <li
            className={activeSubTab === "tankRegistry" ? "active" : ""}
            onClick={() => setActiveSubTab("tankRegistry")}
          >
            Tank Registry
          </li>
          <li
            className={activeSubTab === "orbDeclaration" ? "active" : ""}
            onClick={() => setActiveSubTab("orbDeclaration")}
          >
            IOPP &amp; ORB Declaration
          </li>
        </ul>
      </div>

      <div style={{ display: activeSubTab === "tankRegistry" ? "block" : "none", position: "relative" }}>
        <br />
        <h3 style={{ marginTop: "15px", marginBottom: "10px" }}>
          Tanks Information
        </h3>
        <Button
          type="primary"
          onClick={showHideModal}
          style={{ position: "absolute", right: "0px", top: "20px" }}
        >
          Add Tanks
        </Button>

        <Table
          columns={columns}
          dataSource={FilteredData}
          bordered
          pagination={{ pageSize: 10 }}
          rowKey="key"
          className="custom-table"
        />
      </div>

      <div style={{ display: activeSubTab === "orbDeclaration" ? "block" : "none", paddingTop: "24px" }}>
        <h3 style={{ marginBottom: "16px" }}>IOPP &amp; ORB Declaration</h3>
        <OrbConfiguration id={id} refreshKey={orbConfigurationRefresh} />
      </div>

      <Modal
        title={update_status ? "Update Tank" : "Add Tank"}
        open={isModalOpen}
        onOk={update_status ? UPDATE_TANK_API : ADD_TANK_API}
        onCancel={showHideModal}
      >
        <div class="row">
          <div className="col-12">
            <SelectInput
              label="Tank Type"
              placeholder="Tank Type"
              options={tank_list}
              value={tank_type}
              onChange={(value) => {
                set_tank_type(value);
                set_Oil_Type("");
              }}
              errors={errors?.tank_type}
              style={{ width: "100%" }}
            />
          </div>
        </div>
        {tank_type == 1 && (
          <div class="row">
            <div className="col-12">
              <SelectInput
                label="Fuel Oil Type"
                placeholder="Fuel Type"
                options={fuelTypeOptions}
                value={oil_type}
                onChange={(value) => set_Oil_Type(value)}
                errors={errors.tank_type}
                style={{ width: "100%" }}
              />
            </div>
          </div>
        )}
        {tank_type == 2 && (
          <div class="row">
            <div className="col-12">
              <SelectInput
                label="Lub Oil Type"
                placeholder="Fuel Type"
                options={lubOilTypeOptions}
                value={oil_type}
                onChange={(value) => set_Oil_Type(value)}
                errors={errors.tank_type}
                style={{ width: "100%" }}
              />
            </div>
          </div>
        )}
        <div class="row">
          <div className="col-12">
            <AppInput
              label="Tank Name"
              placeholder="Tank Name"
              value={tank_name}
              onChange={(e) => set_tank_name(e.target.value)}
              errors={errors.tank_name}
            />
          </div>
        </div>
        <div class="row" style={{ marginBottom: "15px" }}>
          <div className="col-12">
            <AppInput
              label="100% capacity (m3)"
              placeholder="capacity"
              value={capacity}
              onChange={(e) => set_capacity(e.target.value)}
              errors={errors.capacity}
            />
          </div>
        </div>
        <div class="row">
          <div className="col-12">
            <SelectInput
              label="Category of tank"
              value={category}
              placeholder=" -- Category of tank  -- "
              style={{ width: "100%" }}
              onChange={(value) => setCategory(value)}
              options={categoryData}
              errors={errors?.category}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default AddTanks;
